a.event = (function(){
	return {}
}());